import React, { useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import CommonGrid from "../../../../components/CommonCompo/CommonGrid/CommonGrid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCommon } from "../../../../Hooks/Common/useCommon";
import PanelHeaderTemplate from "../../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { useReviewing } from "../../../../Hooks/Features/Pocker/useReviewing";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { SkeletonDataTable } from "../../../../components/Loader/Loader";
import RevokePopup from "../../../../components/Poker/RevokePopup";
import CommanDialog from "../../../../components/CommonCompo/CommanDialog/CommanDialog";
import { calculateWordsFromString } from "../../../../utils/Helper";
import { useTheme } from "../../../../context/ThemeContext";
import CommonFilterDropdown from "../../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
import TaskDetailsPopup from "../../../../components/TaskList/TaskDetailsPopup";

function Review() {

  const { checkPermission, getValuePermission } = useCommon();
  const { baseColumns, rowData, option, getReviewingDetails, tagRef, loader, handleData, projectWiseData, totalData, revokeColumn, getDynamicBidderColumns, showPopup, setShowPopup, reasonDetails, setReasonDetails, resultDeclare, revokePopup, setRevokePopup, declareConfirmation, setDeclareConfirmation, CheckEstimate, upsertBucketResultDeclare, expandedGroups, toggleGroup, commonFilter, setCommonFilter, handleMoveToWorkspace, selectedTab, setSelectedTab, filterValues, setFilterValues, taskDetailsPopup, setTaskDetailsPopup } = useReviewing({ getValuePermission });
  const { theme } = useTheme();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

  const tabs = [
    { key: "bucket", label: "Bucket" },
    { key: "workspace", label: "Workspace" },
  ]

  return (

    <div ref={() => checkPermission("Planning", tagRef)}>
      <div ref={tagRef} id='{"tabname": "bucket_planning", "data": "agileplanning_review_tab"}' >
        <div className="d-flex justify-content-between align-items-center my-2 gap-3 px-3">
          <div className="d-flex gap-2 align-items-center flex-grow-1">
            <div className={`tab-menu ${theme === "dark" ? "dark" : ""}`} style={{ minWidth: "220px" }}>
              {tabs?.map(item => (
                <div key={item?.key} className={`tab-menu-item ${item?.key === selectedTab ? `active${theme === "dark" ? "-dark" : ""}` : ""}`} onClick={() => { if (selectedTab !== item?.key) { setSelectedTab(item?.key); getReviewingDetails(item?.key); } }}><FontAwesomeIcon icon={item?.key === "bucket" ? "fa-solid fa-user" : "fa-solid fa-arrow-pointer"} /> {item?.label}</div>
              ))}
            </div>
            <div className="w20 ms-3" style={{ minWidth: "150px" }}>
              <input type="text" className="input-dd w100 mb-0 rounded" placeholder="Issue key" value={commonFilter?.issueKey} onChange={(e) => { setCommonFilter({ ...commonFilter, issueKey: e.target?.value, isChange: true }) }} onBlur={() => { if (commonFilter?.isChange) { getReviewingDetails(null); setCommonFilter({ ...commonFilter, isChange: false }); } }} />
            </div>
            <span className="fw-semibold text-muted ms-3 text-nowrap">{totalData} Tasks</span>
          </div>
          <div className="d-flex gap-2 w65">
            {/* <div className="w75">
              <CommonFilterDropdown filterValues={filterValues} setFilterValues={setFilterValues}
                fields={[
                  { key: "projects", label: "Projects", widthClass: "w20", onHide: () => { handleData(); }, optionValue: "project_id" },
                  { key: "sprint", label: "Sprint", widthClass: "w20", options: projectWiseData?.sprint, onHide: () => { getReviewingDetails(); }, optionValue: "sprint_id" },
                  { key: "issueType", label: "Task Type", widthClass: "w20", options: projectWiseData?.issueType, onHide: () => { getReviewingDetails(); }, optionValue: "issue_type_id" },
                  { key: "subProject", label: "Sub Project", widthClass: "w20", options: projectWiseData?.subProject, onHide: () => { getReviewingDetails(); }, optionValue: "option_id" },
                  { key: "reporters", label: "Reporters", widthClass: "w20", options: projectWiseData?.reporters, onHide: () => { getReviewingDetails(); }, optionValue: "reporter_user_code" },
                ]} />
            </div> */}
           
            <div className="w15">
              <input type="text" className="input-dd w100 rounded" placeholder="Issue key" value={commonFilter?.issueKey} onChange={(e) => { setCommonFilter({ ...commonFilter, issueKey: e.target?.value, isChange: true }) }} onBlur={() => { if (commonFilter?.isChange) { getReviewingDetails(null); setCommonFilter({ ...commonFilter, isChange: false }); } }} />
            </div>
             <div className="w10">
              {/* <Dropdown
                className="sk-multiselect"
                options={option?.groupBy}
                placeholder="Group By"
                value={commonFilter?.groupBy}
                onChange={(e) => { setCommonFilter({ ...commonFilter, groupBy: e.value }) }}
              /> */}
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center gap-1 flex-fill">
             
            {(!getValuePermission("agileplanning_review_declare_btn") && selectedTab === "bucket") && <button className="sk-btn sk-btn-primary text-white bg-black" onClick={() => handleMoveToWorkspace()} title="Move to Work Space"><FontAwesomeIcon icon="fa-solid fa-arrow-right-long" /></button>}
            <button
              className="sk-btn-primary rounded"
              onClick={() => getReviewingDetails(null)}
              title="Refresh"
            >
              <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
            </button>
            <button
              className="sk-btn-primary rounded"
              onClick={() => setShowFiltersDrawer(true)}
              title="Filters"
            >
              <FontAwesomeIcon icon="fa-solid fa-filter" />
            </button>
            <button className="sk-btn-danger rounded" onClick={() => CheckEstimate("revoke")}> <FontAwesomeIcon icon="fa-solid fa-hand-point-left" title="Revoke Selected" /></button>
            {selectedTab === "bucket" && <span ref={tagRef}
              id='{"tabname": "declaregame", "data": "agileplanning_review_declare_btn"}'>
              <button className="button btn-primary rounded" onClick={() => CheckEstimate("declare")}>  <FontAwesomeIcon icon="fa-solid fa-check" title="Declare" /></button>
            </span>}
          </div>
        </div>
        {
          loader ? <SkeletonDataTable numColumns={6} numSkeletons={25} /> :
            <>
              {
                rowData?.length === 0 ? <CommonGrid columns={baseColumns} data={[]} loader={loader} /> : <div style={{ background: theme === "dark" ? "#1f1f21" : "#f8fafc", height: "calc(100vh - 110px)", overflowY: "auto" }} >
                  {
                    Object.entries(rowData).map(([groupKey, groupData]) => {
                      const isExpanded = expandedGroups[groupData?.group_summary] || false;
                      return (
                        <div key={groupKey} className="review-card">
                          <div
                            className="my-1 d-flex justify-content-between align-items-center fw-semibold c-pointer"
                            onClick={() => toggleGroup(groupData?.group_summary)}
                            style={{ cursor: 'pointer' }}
                          >
                            <p
                              title={groupData?.group_summary}
                              className="declare-title text-truncate w85" 
                            >
                              {isExpanded ? <FontAwesomeIcon icon="fa-solid fa-angle-down" /> : <FontAwesomeIcon icon="fa-solid fa-angle-right" />} {groupData?.group_summary}
                            </p>
                            <span className="px-2 align-self-center" style={{
                              border: "1px solid #e0e0e0",
                              borderRadius: "20px",
                              fontSize: "12px"
                            }}>
                              {Object.values(groupData?.issue_types || {}).reduce((total, issues) => total + issues.length, 0)} Tasks
                            </span>
                          </div>
                          {isExpanded && Object.entries(groupData.issue_types).map(([issueType, issues]) => {
                            const data = [{
                              title: "",
                              id: "all",
                              children: issues,
                              category: `${groupData?.group_summary}-${issueType}`
                            }];
                            const bidderColumns = getDynamicBidderColumns(issues);
                            const tableColumns = [...baseColumns, ...bidderColumns, ...revokeColumn];

                            return (
                              <div key={issueType} className="mt-1">
                                <div className="c-pointer">
                                  <div className="my-1 d-flex justify-content-between align-items-center fw-semibold">
                                    <span className="px-2 align-self-center fw-semibold" style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "20px",
                                      fontSize: "12px"
                                    }}>
                                      {issueType}
                                    </span>
                                    <span className="px-2 align-self-center" style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "20px",
                                      fontSize: "12px"
                                    }}>
                                      {data[0]?.children?.length} Tasks
                                    </span>
                                  </div>
                                </div>
                                <div style={{ overflowX: "auto", overflowY: "hidden" }}>
                                  <CommonGrid columns={tableColumns} data={data} headerHeight={50} />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })
                  }
                </div>
              }</>

        }
      </div>
      <Dialog
        className="modal-xsmall"
        visible={showPopup?.show}
        draggable={false}
        onHide={() => { setShowPopup({ show: false }); setReasonDetails({}); }}>
        <div>
          <div>
            <labe>
              <div className="notes">
                {

                  showPopup?.estimate > 0 ?
                    "Estimation time is still active. Selecting a winner will end it. Please provide a reason for your selection." : "Selected user is not a system suggested winner.Please provide a reason for your selection."}

              </div>
            </labe>
            <div className="my-2">
              <label>Select Reason</label>
              <Dropdown
                value={reasonDetails?.reason}
                onChange={(e) => setReasonDetails((prev) => ({ ...prev, reason: e?.target?.value, remark: "" }))}
                placeholder="Select a reason"
                options={option?.reasons}
                optionLabel="reasons"
                filter
                filterInputAutoFocus
                className="input-dd mb-0"
              />
            </div>
            {reasonDetails?.reason?.reason_type_key?.toLowerCase() === "other" && (
              <>
                <label>Remark</label>
                <textarea
                  className="w100"
                  placeholder="Please add remark"
                  value={reasonDetails?.remark}
                  onChange={(e) => setReasonDetails((prev) => ({ ...prev, remark: e?.target?.value }))}
                />
                {(reasonDetails?.reason?.reason_type_key?.toLowerCase() === "other" && calculateWordsFromString(reasonDetails?.remark || "") <= 2) ? calculateWordsFromString(reasonDetails?.remark || "") + "/2 words" : ""}
              </>
            )}
          </div>
          <div className="d-flex gap-2 justify-content-end my-2">
            <button className="button btn-primary" onClick={() => resultDeclare(showPopup?.data, showPopup?.alloted)}>
              Submit
            </button>
          </div>
        </div>
      </Dialog>
      <CommanDialog
        visible={declareConfirmation?.show}
        message={declareConfirmation?.message}
        handleClose={() => { setDeclareConfirmation({ show: false, data: [] }) }}
        handleFun={() => declareConfirmation?.key === "workspace" ? handleMoveToWorkspace(true) : upsertBucketResultDeclare(declareConfirmation?.data)}
      />
      {
        revokePopup?.show && <RevokePopup showPopup={revokePopup} handleClose={() => setRevokePopup({ show: false })} stage={selectedTab === "bucket" ? "reviewing" : "workspace"} apiCall={() => { getReviewingDetails(); setRevokePopup({ show: false }) }} />
      }

      {/* Right Panel Filters Drawer */}
      <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
        <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
          <div className="sk-drawer-header">
            <h5 className="sk-drawer-title">Filters</h5>
            <div className="d-flex align-items-center gap-2">
              <button className="sk-drawer-clear-btn" onClick={() => {
                setCommonFilter({
                  ...commonFilter,
                  projects: [],
                  sprint: [],
                  issueType: [],
                  subProject: [],
                  reporters: [],
                  groupBy: "",
                  isChange: true
                });
              }}>Clear All</button>
              <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                <FontAwesomeIcon icon="fa-solid fa-xmark" />
              </button>
            </div>
          </div>
          <div className="sk-drawer-body">
            <div className='d-flex flex-column gap-4'>
              {/* Group By Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Group By</div>
                <Dropdown
                  className="sk-input-dd w-100"
                  options={option?.groupBy}
                  placeholder="Group By"
                  value={commonFilter?.groupBy}
                  onChange={(e) => { setCommonFilter({ ...commonFilter, groupBy: e.value }) }}
                />
              </div>

              {/* Dimensions Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Dimensions</div>
                <div className="d-flex flex-column gap-2">
                  <MultiSelect
                    className="sk-input-dd w-100"
                    options={option?.projects}
                    optionLabel="project_name"
                    optionValue="project_id"
                    placeholder="Project"
                    value={commonFilter?.projects}
                    filter
                    onChange={(e) => { setCommonFilter({ ...commonFilter, projects: e.value, isChange: true }) }}
                    onHide={() => { if (commonFilter?.isChange) { handleData() } }}
                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'projects', commonFilter?.projects, () => {
                      setCommonFilter({ ...commonFilter, projects: [], isChange: true })
                    })}
                  />
                  <MultiSelect
                    className="sk-input-dd w-100"
                    options={projectWiseData?.sprint}
                    optionLabel="sprint_name"
                    optionValue="sprint_id"
                    placeholder="Sprint"
                    value={commonFilter?.sprint}
                    filter
                    onChange={(e) => { setCommonFilter({ ...commonFilter, sprint: e.value, isChange: true }) }}
                    onHide={() => { if (commonFilter?.isChange) { getReviewingDetails(null) } }}
                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'sprint', commonFilter?.sprint, () => setCommonFilter({ ...commonFilter, sprint: [], isChange: true }))}
                  />
                  <MultiSelect
                    className="sk-input-dd w-100"
                    options={projectWiseData?.issueType}
                    optionLabel="issue_type_name"
                    optionValue="issue_type_id"
                    placeholder="Task Type"
                    value={commonFilter?.issueType}
                    filter
                    onChange={(e) => { setCommonFilter({ ...commonFilter, issueType: e.value, isChange: true }) }}
                    onHide={() => { if (commonFilter?.isChange) { getReviewingDetails(null) } }}
                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'issueType', commonFilter?.issueType, () => setCommonFilter({ ...commonFilter, issueType: [], isChange: true }))}
                  />
                  <MultiSelect
                    className="sk-input-dd w-100"
                    options={projectWiseData?.subProject}
                    optionLabel="project_module_name"
                    optionValue="option_id"
                    placeholder="Sub Project"
                    value={commonFilter?.subProject}
                    filter
                    onChange={(e) => { setCommonFilter({ ...commonFilter, subProject: e.value, isChange: true }) }}
                    onHide={() => { if (commonFilter?.isChange) { getReviewingDetails(null) } }}
                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'subProject', commonFilter?.subProject, () => setCommonFilter((prevState) => ({
                      ...prevState, subProject: [], isChange: true
                    })))}
                  />
                  <MultiSelect
                    className="sk-input-dd w-100"
                    options={projectWiseData?.reporters}
                    optionLabel="user_display_name"
                    optionValue="reporter_user_code"
                    placeholder="Reporters"
                    value={commonFilter?.reporters}
                    filter
                    onChange={(e) => { setCommonFilter({ ...commonFilter, reporters: e.value, isChange: true }) }}
                    onHide={() => { if (commonFilter?.isChange) { getReviewingDetails(null) } }}
                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'reporters', commonFilter?.reporters, () => setCommonFilter((prevState) => ({
                      ...prevState, reporters: [], isChange: true
                    })))}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sk-drawer-footer">
            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
              getReviewingDetails(null);
              setShowFiltersDrawer(false);
            }}>Apply Filters</button>
          </div>
        </div>
      </div>
    </div >
  );
}

export default Review;






